const inputStyles = {
    indicatorSeparator: () => ({
      display: "none"
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: "14px"
    }),
    container: (provided) => ({
      ...provided,
      height: "40px",
      borderRadius: "5px 5px 0 0",
      borderColor: "#6ab4e4",
      width: "100%"
    }),
    control: (provided, state) => ({
      ...provided,
      height: "40px",
      borderRadius: state.isFocused ? "5px 5px 0 0" : "5px 5px 5px 5px",
      borderColor: state.isFocused ? "#6ab4e4" : "#ddd",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#6ab4e4"
      }
    }),
    input: (provided) => ({
      ...provided,
      height: "30px"
    }),
    menu: (provided) => ({
      ...provided,
      marginTop: "0",
      boxShadow: "none"
    }),
    menuList:(provided) => ({
      ...provided,
      fontSize: "12px",
      color: "#444",
      border: "1px solid #ddd",
      boxShadow: "none"
    }),
    option: (provided, state) => ({
      ...provided,
      height: "40px",
      padding: "8px 12px",
      backgroundColor: state.isSelected ? '#6ab4e4' : '#fff',
      color: state.isSelected ? '#fff' : provided.color,
      '&:hover': {
        backgroundColor: '#6ab4e4',
        color: '#fff'
      }
    })
}

export { inputStyles };